import React from "react";
import { Modal, Button } from "react-bootstrap";


export default function Tested({
	isOpen, toggle, testedYes
}) {

	return (
		<Modal show={isOpen} centered className="text-translate-modal">
			<Modal.Header
				className="text-translation d-flex"
				tag="div"
			><Modal.Title className="text-translation popup_heading m-0">
				Do you have seen this question in exam?
			</Modal.Title>

				<Button variant="link" className="modalClose-Btn p-0"  onClick={toggle}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						width="24"
						height="24"
					>
						<path
							d="M18 6L6 18M6 6l12 12"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</Button>
			</Modal.Header>
			
			<Modal.Body>
				<div className="row text-center">
					<div className="col-6">
						<button
							type="button"
							className="outline-btn"
							onClick={testedYes}
						>
							Yes, I've
						</button>
					</div>
					
					<div className="col-6">
						<button
							type="button"
							className="outline-btn "
							onClick={toggle}
						>
							No, I haven’t
						</button>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
}